import { createContext } from 'react';

const PesquisaContext = createContext();

export default PesquisaContext;
